<div
  *ngIf="isEligible && !dismissed && supportChat.available()"
  class="support-chat-nudge"
  [ngClass]="{ 'support-chat-nudge-open': isOpenState }"
>
  <div class="support-chat-nudge-inner">
    <button (click)="openChat()">
      <span> Do you need help? </span>
      <span> Chat with us! </span>
    </button>
  </div>
</div>
